import React from 'react';
import { Box, CircularProgress, Typography, Button } from '@mui/material';
import { LockOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAccess } from '../contexts/AccessContext';
import PrivateRoute from './PrivateRoute';

// Admin pages: signed in AND an admin. This only hides the page; the data behind it is
// protected in the database (admin_* functions refuse non-admins).
const AdminGate = ({ children }) => {
  const { isAdmin, adminChecked } = useAccess();
  const navigate = useNavigate();
  if (!adminChecked) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}><CircularProgress /></Box>;
  }
  if (!isAdmin) {
    return (
      <Box sx={{ textAlign: 'center', py: 10, px: 3 }}>
        <LockOutlined sx={{ fontSize: 48, color: 'text.disabled' }} />
        <Typography variant="h5" sx={{ fontWeight: 700, mt: 1 }}>Admins only</Typography>
        <Typography color="text.secondary" sx={{ mt: 1, mb: 3 }}>You don't have access to this page.</Typography>
        <Button variant="contained" onClick={() => navigate('/')}>Go to Dashboard</Button>
      </Box>
    );
  }
  return children;
};

const AdminRoute = ({ children }) => (
  <PrivateRoute>
    <AdminGate>{children}</AdminGate>
  </PrivateRoute>
);

export default AdminRoute;
